import { render, staticRenderFns } from "./detailsClients.vue?vue&type=template&id=55e1f7c0&"
import script from "./detailsClients.vue?vue&type=script&lang=js&"
export * from "./detailsClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports